import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { delay, Observable, of, Subject, takeUntil } from 'rxjs';
import { MaterialModule } from 'src/app/modules/material/material.module';
import { BottomPopupService } from 'src/app/services/bottom-popup.service';
import { LikutWarehouseService } from 'src/app/services/likut-warehouse.service';
import { LOCALES, LocalesEnum, LocaleService, LOCALE_PREFERENCE } from 'src/app/services/locale.service';
import { StoreService } from 'src/app/services/store.service';

export type SearchOptions = '' | 'Name' | 'Code' | 'Barcode' | 'ItemExtra1';
type PreferencesList = { name: string; value: LocalesEnum | null };

@Component({
	selector: 'app-language-change',
	// templateUrl: './search-preference.component.html',
	styleUrls: ['./language-change.component.scss'],
	template: `
		<div class="product-detail-add__popup popup__content">
			<div class="product-detail__wrapper">
				<div class="product-detail__item">
					<div class="popup__close" style="position: absolute; top: 0px; background-color: black"></div>
					<h3 style="text-align: center">בחר העדפה</h3>
					<div class="shop-filter__row" *ngFor="let choice of preferences" style="position: relative">
						<label class="shop-filter__radio custom-radio" style="font-weight: bold">
							{{ choice.name }}
							<input type="radio" name="shop-filter" [formControl]="preferenceRadioControl" [value]="choice.value" />
							<span class="custom-radio__checkmark"></span>
						</label>
					</div>

					<!-- <div class="product-detail-add__popup-row">
						<button class="product-detail-add__popup-button">חזור</button>
					</div> -->
				</div>
			</div>
		</div>
	`,
	// styles: [``],
	imports: [MaterialModule, CommonModule, ReactiveFormsModule],
	standalone: true,
})
export class LanguageChangeComponent implements OnInit, OnDestroy {
	private _locale = inject(LocaleService);
	private _bottomPopup = inject(BottomPopupService);
	private _likutWarehouse = inject(LikutWarehouseService);

	preferences: PreferencesList[] = [
		{ name: 'שכח בחירה', value: null },
		{ name: 'עברית', value: LOCALE_PREFERENCE.HEBREW },
		{ name: 'משולב', value: LOCALE_PREFERENCE.DISPLAY_BOTH },
		{ name: 'ערבית ', value: LOCALE_PREFERENCE.ARABIC },
	];

	preferedChoice: LocalesEnum = this._likutWarehouse.forcedButtonsAndTextTypeof$.value;

	preferenceRadioControl = new FormControl<LocalesEnum | null>(this.preferedChoice);

	destroy$ = new Subject<void>();
	constructor() {}

	ngOnInit(): void {
		this.preferenceRadioControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
			this._likutWarehouse.updateButtonsTextFrocedTypeof(value);
		});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();

		if (this.preferenceRadioControl.value) {
			this._locale.setLocale(LOCALES[this.preferenceRadioControl.value]);
		}

		this._bottomPopup.dismiss();
	}
}
